export default __webpack_public_path__ + "static/media/90.e1a61d83.jpg";